/**
 * User API Endpoints
 * User profile management
 */

import apiClient from '../client';

export interface UpdateUserProfileParams {
  user: {
    first_name?: string;
    last_name?: string;
    email?: string;
    phone_number?: string;
    gender?: string;
  };
}

export interface UserResponse {
  id: string;
  user_id: string;
  username: string;
  email: string;
  phone_number?: string;
  first_name?: string;
  last_name?: string;
  gender?: string;
  buyer_onboarding_step: number;
  seller_onboarding_step: number;
  profile_picture_url?: string;
}

export const usersApi = {
  /**
   * GET /users/account
   * Get current user account information
   */
  getAccount: async (): Promise<UserResponse> => {
    const response = await apiClient.get<UserResponse>('/users/account');
    return response.data;
  },

  /**
   * PUT /users/account
   * Update current user profile
   */
  updateProfile: async (params: UpdateUserProfileParams): Promise<UserResponse> => {
    const response = await apiClient.put<UserResponse>('/users/account', params);
    return response.data;
  },
};
